export const sliderConfig = {
    container: '.base-full-carouselGalleryContainer',
    slideBy: 'page',
    autoplay: false,
    center: false,
    swipeAngle: false,
    loop: false,
    controls: false,
    responsive: {
        360: {
            items: 1,
            fixedWidth: false,
            gutter: 16,
            edgePadding: 30,
            controls: false,
            nav: false,
        },
        575: {
            items: 1,
            fixedWidth: false,
            gutter: 16,
            edgePadding: 50,
            controls: false,
            nav: false,
        },
        768: {
            items: 1,
            fixedWidth: false,
            gutter: 16,
            edgePadding: 120,
            controls: false,
            nav: false,
        },
        992: {
            items: 1,
            // fixedWidth: 700,
            gutter: 26,
            controls: false,
            nav: false,
            edgePadding: 300,
        }
    }
}
